import {
	SpeedFactorUtcMidnightSplitGroup,
	SpeedFactorUtcMidnightSplitData,
	SpeedFactorOriginalEventShared
} from '../types';

const proxyHandler = {
	get(target: SpeedFactorUtcMidnightSplitData, prop: keyof SpeedFactorOriginalEventShared, ...rest) {
		switch (prop) {
			case 'id':
			case 'factor':
			case 'day_of_week':
			case 'interval_start':
			case 'start_date':
			case 'end_date':
			case 'service_area_id':
			case 'original_uuid':
				return target.start[prop];
			case 'interval_end':
				return target.end.interval_end;
			default:
				return Reflect.get(target, prop, ...rest);
		}
	}
};
export const createProxy = (group: SpeedFactorUtcMidnightSplitData) => {
	return new Proxy(group, proxyHandler) as SpeedFactorUtcMidnightSplitGroup;
};
